// Development environment configuration
export const environment = {
  production: false,
  name: 'dev',
  apiUrl: 'https://api-dev.kruxible.com/api',
  videoApiUrl: 'https://api-dev.kruxible.com/api/videos',
  enableDebug: true,
  enableMockData: false,
  sentryDsn: '',
  // Placeholder, NO cadena vacía: docker-entrypoint.sh solo sustituye este literal, así que con
  // '' el botón de Google no aparece en el entorno DEV de Railway por mucho que se configure
  // GOOGLE_CLIENT_ID. Mismo valor que environment.prod.ts.
  googleClientId: 'GOOGLE_CLIENT_ID_PLACEHOLDER',
  // Comunidad (Skool): destino del CTA de la sección "Comunidad" de Explore.
  skoolUrl: 'https://www.skool.com/sim-club'
};
